<template src="./Academic.html"></template>

<script>
import ArrobaMedellinArrobitaNoData from "@/components/ArrobaMedellinArrobitaNoData/ArrobaMedellinArrobitaNoData";
import ArrobaMedellinHorizontalCard from "@/components/ArrobaMedellinHorizontalCard/ArrobaMedellinHorizontalCard";
import ArrobaMedellinHorizontalCardAcademic from "@/components/ArrobaMedellinHorizontalCardAcademic/ArrobaMedellinHorizontalCardAcademic";
import ArrobaMedellinSeeker from "@/components/ArrobaMedellinSeeker/ArrobaMedellinSeeker";
import ArrobaMedellinVerticalCard from "@/components/ArrobaMedellinVerticalCard/ArrobaMedellinVerticalCard";
import ArrobaMedellinVerticalCardAcademic from "@/components/ArrobaMedellinVerticalCardAcademic/ArrobaMedellinVerticalCardAcademic";
import CourseInfoModal from "@/components/CourseInfoModal/CourseInfoModal";
import tutorial from "@/mixins/tutorial";
import coursesService from "@/services/Courses";
import { roleName } from "@/utils/constants";
import swiperSmallOption from "@/utils/swiper-small-option";
import { SwiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
import RecommendedCoursesInstitutions from "../../components/RecommendedCoursesInstitutions/RecommendedCoursesInstitutions";
import DinamicListFilter from "./DinamicListFilter/DinamicListFilter";

export default {
  name: "academic",
  mixins: [tutorial],
  components: {
    CourseInfoModal,
    SwiperSlide,
    ArrobaMedellinHorizontalCardAcademic,
    ArrobaMedellinHorizontalCard,
    ArrobaMedellinVerticalCard,
    ArrobaMedellinVerticalCardAcademic,
    ArrobaMedellinSeeker,
    DinamicListFilter,
    ArrobaMedellinArrobitaNoData,
    RecommendedCoursesInstitutions,
  },
  data() {
    return {
      showCourseDetail: false,
      typeCard: { button: "button--purple", progress: "is-warning" },
      typeCardInterestedCourses: { size: "small" },
      swiperSmallOption: swiperSmallOption,
      roleName,
      courses: [],
      coursesInProgress: [],
      lastActivities: [],
      nameProgram: "",
      recommendedCourses: [],
      coursesInstitutions: [],
      filteredCourses: [],
      institutionId: "12",
      programId: "77",
      institutions: [],
      category: "Educación continua",
      userInfo: null,
      errorMessage: false,
      noCourses: false,
      itemsToShow: Number(4),
      isCardModalInstitution: false,
      institution: {},
      showAgendaModal: false,
      showImageModal: false,
      selectedImage: null,
      agendaItemsToShow: 3,
      agendaEvents: (() => {
        const ctx = require.context(
          "@/assets/img/agenda",
          false,
          /\.(jpg|jpeg|png|gif|webp)$/i
        );
        return ctx
          .keys()
          .map((key) => {
            const filename = key
              .replace("./", "")
              .replace(/\.(jpg|jpeg|png|gif|webp)$/i, "");
            const sep = filename.indexOf("_");
            const date = sep !== -1 ? filename.substring(0, sep) : filename;
            const title = sep !== -1 ? filename.substring(sep + 1) : filename;
            return { date, title, image: ctx(key) };
          })
          .sort((a, b) => {
            const dayA = parseInt(a.date) || -1;
            const dayB = parseInt(b.date) || -1;
            return dayA - dayB;
          });
      })(),
      coursesRecommendationsMedellin: [],
      coursesRecommendationsInstitution: [],
      listLastCourses: [],
      courseIdModal: null,
      modalEditable: false,
      courseImage: "",
    };
  },
  beforeMount() {
    this.role = this.user.role.name;
  },
  mounted() {
    this.getAcademicData();
    this.reportWindowSize();
    window.addEventListener("resize", this.reportWindowSize);
    this.updateAgendaItemsToShow();
    window.addEventListener("resize", this.updateAgendaItemsToShow);
    this.viewTutorial();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.reportWindowSize);
    window.removeEventListener("resize", this.updateAgendaItemsToShow);
  },
  methods: {
    async continueCourse(courseCode) {
      let pendingWindow = null;
      try {
        if (!courseCode) {
          throw new Error("No se encontró el código del curso");
        }

        pendingWindow = window.open("", "_blank");

        const response = await coursesService.getCourseUrl(courseCode);
        const url =
          typeof response === "string" ? response : response?.url || null;
        if (!url) {
          throw new Error("No se encontró la URL del curso");
        }

        if (pendingWindow && !pendingWindow.closed) {
          pendingWindow.opener = null;
          pendingWindow.location.href = url;
        } else {
          window.location.assign(url);
        }
      } catch (e) {
        if (pendingWindow && !pendingWindow.closed) {
          pendingWindow.close();
        }
        this.$buefy.toast.open({
          duration: 5000,
          message: "No fue posible abrir el curso. Intenta nuevamente.",
          position: "is-bottom",
          type: "is-danger",
        });
        console.error("Error opening course", e);
      }
    },
    updateAgendaItemsToShow() {
      if (window.innerWidth < 768) {
        this.agendaItemsToShow = 1;
      } else if (window.innerWidth < 1024) {
        this.agendaItemsToShow = 2;
      } else {
        this.agendaItemsToShow = 3;
      }
    },
    async getAllCoursesRecommendations() {
      try {
        this.coursesRecommendationsMedellin =
          await coursesService.getAllCoursesRecommendations("@medellin");
        this.coursesRecommendationsInstitution =
          await coursesService.getAllCoursesRecommendations("Universidad");
      } catch (e) {
        console.log("e", e);
      }
    },
    searchCourseOrCategory(searchWord) {
      coursesService
        .getByCourseOrCategory(searchWord)
        .then((response) => {
          if (response.length < 1) {
            this.errorMessage = true;
          } else {
            this.filteredCourses = response;
            this.category = `con la palabra ${searchWord}`;
            this.errorMessage = false;
            this.nameProgram = null;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getCoursesByFilterList(idProgram, idInstitution, categoryName) {
      this.institutionId = idInstitution;
      this.programId = idProgram;
      coursesService
        .getCoursesByProgram(idProgram, idInstitution)
        .then((response) => {
          const courses = response[0].courses;
          if (courses.length) {
            this.filteredCourses = courses;
            this.category = categoryName;
          }
        });
    },
    async getCoursesByFilterListCategory(categoria_id) {
      try {
        let response = [];
        if (categoria_id) {
          response = await coursesService.getCoursesByCategory(categoria_id);
        }
        const courses = response;
        const categoryName = response[0].nameCategory;
        if (courses.length) {
          this.filteredCourses = courses;
          this.category = categoryName;
          this.nameProgram = null;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getCoursesByFilterListProgram(program_id, name) {
      try {
        let response = [];
        if (program_id) {
          response = await coursesService.returnCoursesForProgram(program_id);
        } else {
          return null;
        }
        if (response.length > 0) {
          const courses = response;
          const categoryName = name;
          if (courses.length) {
            this.filteredCourses = courses;
            this.category = categoryName;
            this.nameProgram = name;
          } else {
            return null;
          }
        } else {
          this.filteredCourses = [];
        }
      } catch (error) {
        console.error(error);
      }
    },
    async openCourseUrl() {
      try {
        const getInstitutions = await coursesService.getInstitutions();
        const institutionsList = getInstitutions.map((institution) => ({
          institutionName: institution.institucion.nombre,
          id: institution.institucion.id,
        }));
        this.institutions = institutionsList;
        this.isCardModalInstitution = true;
      } catch (error) {
        this.$buefy.toast.open({
          duration: 5000,
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
        console.error("error", error);
      }
    },
    openCourseRecommendedUrl(url) {
      if (url.length) {
        window.open(url, "_blank");
      }
    },
    pushButtonModal(code) {
      coursesService
        .getInstitutionsUrlMoodle(code)
        .then((url) => {
          if (url) {
            window.open(url);
          } else {
            this.$buefy.toast.open({
              duration: 5000,
              position: "is-bottom",
              message: "Se presento un error al abrir la URL",
              type: "is-danger",
            });
          }
        })
        .catch((error) => {
          this.error = error;
          console.error("Error on pushButtonModal", error);
        });
    },
    pushButtonModalCourse(code) {
      coursesService
        .getUrlCourseMoodle(code)
        .then((url) => {
          if (url) {
            window.open(url);
          } else {
            this.$buefy.toast.open({
              duration: 5000,
              position: "is-bottom",
              message: "Se presento un error al abrir la URL",
              type: "is-danger",
            });
          }
        })
        .catch((error) => {
          this.error = error;
          console.error("Error on pushButtonModal", error);
        });
    },
    redirectTo(route) {
      this.$router.push({ path: `${route}`, query: { district: "academic" } });
    },
    // TODO: Esta funcion se repite en muchos lugares
    imageCourse(image) {
      if (image) {
        if (image.substring(0, 4) === "http") {
          return image;
        }
        return process.env.VUE_APP_ARROBA + "/images/cursos/" + image;
      }
      return null;
    },
    async getAcademicData() {
      try {
        this.filteredCourses =
          await coursesService.getContinuosEducationCourses(2, 0);
        await this.getAllCoursesRecommendations();
      } catch (error) {
        console.error(error);
      }
      try {
        const getInstitutions = await coursesService.getInstitutions();
        const institutionsList = getInstitutions.map((institution) => ({
          institutionName: institution.institucion.nombre,
          id: institution.institucion.id,
        }));
        this.institutions = institutionsList;
      } catch (error) {
        console.error(error);
      }
      try {
        if (this.role === this.roleName.ADMINISTRATOR) {
          this.lastActivities = await coursesService.getLastCoursesGeneral();
        } else {
          this.lastActivities = await coursesService.getMyCourses();
          console.log("this.lastActivities ", this.lastActivities);
        }
        this.noCourses = this.lastActivities.length;
      } catch (error) {
        console.error(error);
      }
      try {
        this.recommendedCourses =
          await coursesService.getAllCoursesRecommendations("@Medellin");
        this.coursesInstitutions = await coursesService.getRecommended();
      } catch (error) {
        console.error(error);
      }
    },
    reportWindowSize() {
      if (window.innerWidth < 768) {
        this.itemsToShow = 1;
      } else if (window.innerWidth < 1024) {
        this.itemsToShow = 2;
      } else if (window.innerWidth < 1400) {
        this.itemsToShow = 3;
      } else {
        this.itemsToShow = 4;
      }
    },
    viewTutorial() {
      this.dataTutorial("academic");
    },
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    institutionUrl() {
      return this.institutions.filter(
        (inst) =>
          inst.idInstitution === parseInt(this.institutionId) && inst.url
      );
    },
  },
  watch: {
    user: function (value) {
      this.user = value;
    },
  },
};
</script>

<style lang="scss" scoped src="./Academic.scss"></style>
